/* eslint-disable react/display-name */
import React, { ReactElement } from 'react';

const ExampleBranding = React.lazy(() => import('./branding/ExampleBranding/ExampleBranding'));
const ObosBranding = React.lazy(() => import('./branding/ObosBranding/ObosBranding'));
const ShhBranding = React.lazy(() => import('./branding/ShhBranding/ShhBranding'));
const LeksandBranding = React.lazy(() => import('./branding/LeksandBranding/LeksandBranding'));
const TredenordGoldenBranding = React.lazy(() => import('./branding/TredenordGolden/TredenordGolden'));
const BirgerBranding = React.lazy(() => import('./branding/BirgerBranding/BirgerBranding'));
const HusmanBranding = React.lazy(() => import('./branding/HusmanBranding/HusmanBranding'));
const TREDENordBranding = React.lazy(() => import('./branding/3DNordBase/3DNordBase'));
const DiosBranding = React.lazy(() => import('./branding/DiosBranding/DiosBranding'));



let appBranding: string;

const loadBrandingStyle = (branding: string): ReactElement => {
    switch (branding) {
    case 'obos':
        return <ObosBranding/>;
    case 'example':
        return <ExampleBranding/>;
    case 'shh':
        return <ShhBranding/>;
    case 'husman':
        return <HusmanBranding/>;
    case 'birger':
        return <BirgerBranding/>;
    case 'dios':
        return <DiosBranding/>;
    case 'leksand':
        return <LeksandBranding/>;
    default:
        return <TredenordGoldenBranding/>;
    }
};

const getBranding = (branding: string): ReactElement => {
    return <><TREDENordBranding/>{loadBrandingStyle(branding)}</>;
};

const BrandingService = {

    init: (branding: string): ReactElement => {

        if (!appBranding) {
            appBranding = branding;
        }

        return (
            <React.Suspense fallback={<></>}>
                {getBranding(branding)}
            </React.Suspense>
        );
    },

    check: (value: string[]): boolean => !!value.find(v => v === appBranding)
};


export default BrandingService;